
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Purposes } from './models/models';


@Component({
  selector: 'app-load-purposes',
  templateUrl: './load-purposes.component.html',
  styleUrls: ['./load-purposes.component.scss'],
  standalone: false
})
export class LoadPurposesComponent {

  @Input() listPurposes!: Purposes[];
  @Output() purposeToggle: EventEmitter<{ id: string; checked: boolean }> = new EventEmitter();

  onPurposeToggle(item: Purposes, event: Event) {
    let checked = false;
    try {
      const anyEvent: any = event as any;
      if (anyEvent && typeof anyEvent.checked === 'boolean') {
        checked = anyEvent.checked;
      } else {
        const target = event.target as HTMLInputElement | null;
        checked = target?.checked ?? false;
      }
    } catch (e) {
      console.error(e);
      checked = false;
    }
    this.purposeToggle.emit({ id: item.id, checked });
  }

}
